import { z } from 'zod';

type PasswordValidationCode = 'tooShort' | 'noDigit' | 'noLower' | 'noUpper' | 'noSpecial';

const validatePassword = (value: string): PasswordValidationCode | undefined => {
  if (value.length < 10) return 'tooShort';
  if (!/\d/.test(value)) return 'noDigit';
  if (!/[a-z]/.test(value)) return 'noLower';
  if (!/[A-Z]/.test(value)) return 'noUpper';
  if (!/[^a-zA-Z\d]/.test(value)) return 'noSpecial';
};

export const buildZodPassword = (t: (key: string, options?: Record<string, unknown>) => string) =>
  z.custom<string>(
    v => !validatePassword(v as string),
    v => {
      const code = validatePassword(v as string);
      return { message: code ? t(`authPasswordSetup.passwordValidation.${code}`) : '' };
    },
  );
